import { render, staticRenderFns } from "./itemsHeader.vue?vue&type=template&id=2cede089"
import script from "./itemsHeader.vue?vue&type=script&lang=js"
export * from "./itemsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterPills: require('/home/ubuntu/containers/hermes_eshop/components/core/filterPills.vue').default})
